import { Link } from 'react-router-dom';
import type { Product } from '@/api/models';
import { GarmentVisual } from '@/components/garment/GarmentVisual';
import { formatMoney } from '@/lib/money';

/** Product card that turns to show the back on hover or keyboard focus. */
export function FlipTile({ product: p }: { product: Product }) {
  return (
    <Link className="tile" to={`/product/${p.slug}`}>
      <div className="flip" aria-hidden="true">
        <div className="card">
          <div className="face front"><GarmentVisual garment={p.garment} images={p.images} decorative sizes="(max-width: 600px) 45vw, 200px" /></div>
          <div className="face back"><GarmentVisual garment={p.garment} images={p.images} face="back" decorative sizes="(max-width: 600px) 45vw, 200px" /></div>
        </div>
      </div>
      <div className="tn">{p.name}</div>
      <div className="tp">{formatMoney(p.price, p.currency)}</div>
    </Link>
  );
}
